import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { SerialSequenceUpdateNameModal } from './SerialSequenceUpdateNameModal'

type SerialSequenceUpdateNameActivityProps = {
  refetchQuery: string
  serialSequenceId: string
}

export const SerialSequenceUpdateNameActivity: ActivityComponent<
  SerialSequenceUpdateNameActivityProps
> = (data) => {
  const { open, closeActivity } = useActivity()

  return (
    <SerialSequenceUpdateNameModal
      isOpen={open}
      onClose={closeActivity}
      refetchQuery={data.refetchQuery}
      serialSequenceId={Number(data.serialSequenceId)}
    />
  )
}
